import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "../styles/header.css";

const Header = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const getPageTitle = () => {
        switch (location.pathname) {
            case "/training":
                return "Training Portal";
            case "/web-demo":
                return "Web Demo";
            case "/create-user":
                return "Create User";
            default:
                return "";
        }
    };

    const handleLogout = () => {
        localStorage.removeItem("jwt");
        navigate("/login");
    };

    return (
        <header className="header-container">
            <div className="header-brand">
                <span className="company-name">Intersign AI</span>
                <span className="portal-name">Web Portal ®</span>
            </div>
            
            <div className="page-title">
                {getPageTitle()}
            </div>

            <div className="nav-buttons">
                <button className="back-button" onClick={() => navigate("/")}>
                    Back to Hub
                </button>
                <button className="logout-button" onClick={handleLogout}>
                    Logout
                </button>
            </div>
        </header>
    );
};

export default Header;